import http from 'plugins/axios';

export default {
    getAllCoins(data) {
        return http.get({
            url: '/admin/coin/all',
            data
        });
    },
    getBalanceBySnapshootTime(data) {
        return http.get({
            url: '/admin/data/balance',
            data
        });
    },
    getBalanceNow(data) {
        return http.get({
            url: '/admin/data/balancePosition',
            data
        });
    },
    getUserLoginCount(data) {
        return http.get({
            url: '/admin/data/userLoginCount',
            data
        });
    },
    getUserRegisterCount(data) {
        return http.get({
            url: '/admin/data/userRegisterCount',
            data
        });
    },
    getCurrentBalance(data) {
        return http.get({
            url: '/admin/data/current',
            data
        });
    },
    getCurrentLock(data) {
        return http.get({
            url: '/admin/data/currentLock',
            data
        });
    },
    getCurrentRank(data) {
        return http.get({
            url: '/admin/data/currentRank',
            data
        });
    },
    getContractTransfer(data) {
        return http.get({
            url: '/admin/data/contractTransfer',
            data
        });
    },
    getContractUser(data) {
        return http.get({
            url: '/admin/data/contractUser',
            data
        });
    },
    getTradeFeeTime(data) {
        return http.get({
            url: '/admin/data/tradeFee',
            data
        });
    },
    getPledgeUser(data) {
        return http.get({
            url: '/admin/data/pledgeUserData',
            data
        });
    },
    getTribeCheifProfit(data) {
        return http.get({
            url: '/admin/data/tribeCheifProfit',
            data
        });
    },
    getTribeMemberProfit(data) {
        return http.get({
            url: '/admin/data/tribeMemberProfit',
            data
        });
    },
    getListingApplyData(data) {
        return http.get({
            url: '/admin/data/listing/apply',
            data
        });
    },
    getTotalStakingPosition(data) {
        return http.get({
            url: '/admin/data/stakingTotal',
            data
        })
    },
    getUsetStakingPosition(data) {
        return http.get({
            url: '/admin/data/stakingPosition',
            data
        })
    },
    getTradeVolumeData(data) {
        return http.get({
            url: '/admin/data/trade/volume',
            data
        })
    },
    getTradeOrderData(data) {
        return http.get({
            url: '/admin/data/trade/userOrder',
            data
        })
    },
    getUnFinishTradeOrderData(data) {
        return http.get({
            url: '/admin/data/trade/unFinishOrder',
            data
        })
    },
    getDepositWithdrawByTime(data) {
        return http.get({
            url: '/admin/data/depositWithdraw',
            data
        });
    },
    getWithdrawFreeze(data) {
        return http.get({
            url: '/admin/data/withdrawFreeze',
            data
        });
    },
    getTxRecord(data) {
        return http.get({
            url: '/admin/data/txRecod',
            data
        });
    },
    getTxStatistics(data) {
        return http.get({
            url: '/admin/data/txStatistics',
            data
        });
    },
    getItxRecord(data) {
        return http.get({
            url: '/admin/tx/internal/list',
            data
        });
    },

    queryUserCount(data) {
        return http.get({
            url: '/admin/data/kycUserCount',
            data
        })
    },

    /**
     * 手续费查询
     */
    queryFee(data) {
        return http.get({
            url: '/admin/agents/fee/statistic',
            data
        })
    },

    /**
     * 充值提现可视化数据查询
     */
    getDepositVisual(data) {
        return http.get({
            url: '/admin/dw/visual/deposit',
            data
        })
    },
    getWithdrawVisual(data) {
        return http.get({
            url: '/admin/dw/visual/withdraw',
            data
        })
    },
    exportTxRecord(data) {
        return http.get({
            url: '/admin/data/txRecord/export',
            data,
            responseType: 'blob'
        })
    },
    /**
     * 充提整体数据
     */
    getDwSummary(data) {
        return http.get({
            url: '/admin/wallet/reconciliation/list',
            data
        })
    },
    // 添加退回数据
    addReturn(data) {
        return http.post({
            url: '/wallet/admin/deposit/return/add',
            data
            // dataType: 'form'
        })
    },
    // 获取退回列表数据
    getAllRecordByStatus(data) {
        return http.get({
            url: '/wallet/admin/deposit/return/getAllRecordByStatus',
            data
        })
    },
    // 修改退回数据
    updateReturn(data) {
        return http.post({
            url: '/wallet/admin/deposit/return/updateRecord',
            data,
            dataType: 'form'
        })
    },
    // 根据ID查询
    getById(data) {
        return http.get({
            url: '/wallet/admin/deposit/return/getById',
            data
        })
    },
    // 上传退回表格
    importReturnExcel(data) {
        return http.post({
            url: "/wallet/admin/deposit/return/import/returnExcel",
            data,
            dataType: "file",
        })
    },
    getCoinTypeList() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
};
